// extracted by mini-css-extract-plugin
export var dot = "dotplot-module--dot--nRcm7";
export var dotsContainer = "dotplot-module--dots-container--Z-RCK";
export var dotsGroup = "dotplot-module--dots-group--5kHKb";